import './styles.scss'

import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'

const FloatingField = ({
  disabled,
  input: { value, onChange },
  maxLength,
  meta: { touched, error } = {},
  onBlur,
  onChangeAction,
  placeholder
}) => {
  const [focus, setFocus] = useState(false)
  const fieldRef = useRef(null)

  const handleFocusClick = () => {
    if (fieldRef && fieldRef.current) {
      fieldRef.current.focus()
    }
  }

  const handleFocus = () => setFocus(true)

  const handleBlur = () => {
    setFocus(false)
    onBlur && onBlur()
  }

  const handleUpdateValue = event => {
    onChangeAction && onChangeAction(event.target.value)
    onChange(event)
  }

  return (
    <span className={`floating-field${touched && error ? ' with-error' : ''}`}>
      <label className={value || focus ? 'floating' : 'in-field'} onClick={handleFocusClick}>
        {placeholder}
      </label>

      <input
        className='input-text'
        disabled={disabled}
        maxLength={maxLength}
        onBlur={handleBlur}
        onChange={handleUpdateValue}
        onFocus={handleFocus}
        placeholder=''
        ref={fieldRef}
        type='text'
        value={value}
      />
      {touched && error && <div className='floating-error'>{error}</div>}
    </span>
  )
}

FloatingField.propTypes = {
  disabled: PropTypes.bool,
  input: PropTypes.object.isRequired,
  maxLength: PropTypes.number,
  meta: PropTypes.object,
  onBlur: PropTypes.func,
  onChangeAction: PropTypes.func,
  placeholder: PropTypes.string
}

export default FloatingField
